// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as FormInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";

function SuspensionSelectReasonCmp(Props) {
  var handleUpdate = Props.handleUpdate;
  var suspensionOptions = Props.suspensionOptions;
  var result = Props.result;
  var value = Props.value;
  return React.createElement(FormSelectInput$Catalyst.make, {
              input_props: FormInput$Catalyst.make_props("Pick Suspension Reason", Curry.__1(handleUpdate), undefined, undefined, undefined, undefined, undefined, undefined, result, undefined, "max-width", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
              select_props: {
                value: value,
                items: suspensionOptions,
                isNoneRequired: true
              }
            });
}

var make = SuspensionSelectReasonCmp;

export {
  make ,
  
}
/* react Not a pure module */
